import { addCookie, getCookie, storage } from '@bfe/by-storage';
import { guid as Guid, getQueryParams } from '@bfe/by-helpers';
import { BYBIT_GUID_KEY } from '@bfe/by-shared-settings';
import createFetchInstance from '@bfe/by-fetch';
import { RUNTIME_ENV, repaired_hostname } from '@bfe/by-env';

function urlCacheClosure() {
  var cacheList = [];
  return function getUrlQueryFn() {
    var link = window.location.href;

    if (!cacheList[link]) {
      cacheList[link] = getQueryParams(window.location);
    }

    return cacheList[link];
  };
} // 唯一key


function getPrimaryKey() {
  return "".concat(String(Date.now()), "-").concat(String(Math.random()));
}

function getUserAgent() {
  return window.navigator && window.navigator.userAgent;
}

function setUCache() {
  var cacheId = storage.get('BYBIT_GA_UID');

  if (window.GA_UID && cacheId !== window.GA_UID) {
    storage.set('BYBIT_GA_UID', window.GA_UID);
  }
} // Differentiate cache or current GA_UID


function getUCache() {
  return storage.get('BYBIT_GA_UID') || '';
}

function getTdId() {
  return storage.get('BYBIT_TDID_V2') || '';
}

function getUid() {
  setUCache();
  return window.GA_UID || 0;
} // DM Requirement: Use api from tdid "match.adsrvr.org", solution provide by "大数据团队" Ethan Chen


function setTdId() {
  var SCRIPT_ID = 'bybit_tdid_js';

  if (!window.OpenID) {
    window.OpenID = {
      getIds: function getIds() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (data.TDID) {
          storage.set('BYBIT_TDID_V2', data.TDID);
        }
      }
    };
  }

  if (!getTdId() && !document.getElementById(SCRIPT_ID)) {
    var scriptEle = document.createElement('script');
    scriptEle.setAttribute('id', SCRIPT_ID);
    scriptEle.src = 'https://match.adsrvr.org/track/rid?ttd_pid=39yincw&v=1.0.0';
    document.getElementsByTagName('head')[0].appendChild(scriptEle);
  }
} // 获取 clientId 兼容


function getGaClientId() {
  // 尝试获取 ga的clientId
  if (window.ga) {
    var tracingList = window.ga.getAll && window.ga.getAll() || [];

    if (tracingList.length) {
      return tracingList[0].get('clientId');
    }
  } // 不一定有 window.ga 所以直接取cookie


  var cookieGa = getCookie('_ga');

  if (cookieGa) {
    // GA1.1.1952471499.1605507100
    return cookieGa.slice(6);
  }

  return 'none client id';
}

function getLoggerInstance() {
  var loggerHttpOpts = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  var loggerHttpInstance = createFetchInstance(loggerHttpOpts);
  loggerHttpInstance.interceptors.response.push(function (wrappedResp) {
    var _wrappedResp$data;

    if (wrappedResp && (wrappedResp === null || wrappedResp === void 0 ? void 0 : (_wrappedResp$data = wrappedResp.data) === null || _wrappedResp$data === void 0 ? void 0 : _wrappedResp$data.ret_msg) === 'OK') return Promise.resolve();
    return Promise.reject('Non Response!');
  });
  return loggerHttpInstance;
}

function getReportUrl() {
  // const buildEnv = process.env.BYBIT_BUILD_ENV || 'local';
  var reportUrl = "https://api.ffbbbdc6d3c353211fe2ba39c9f744cd.com/p/report?env=".concat(RUNTIME_ENV);
  return reportUrl;
}

var getCookieDomain = function getCookieDomain() {
  return repaired_hostname.indexOf('localhost') !== -1 ? 'localhost' : repaired_hostname.replace(/^(www|m|testnet|blog-test)/, '');
};

var cacheCookie = function cacheCookie(channelCookieKey, content) {
  var domain = getCookieDomain();
  var cookieCacheTime = 7 * 24 * 60;
  addCookie(channelCookieKey, JSON.stringify(content), domain, '/', cookieCacheTime);
};

var getGuid = function getGuid() {
  var guid = getCookie(BYBIT_GUID_KEY);

  if (!guid || guid.length !== 36) {
    guid = Guid();
  } // Do this to refresh cookie's remaining time.


  addCookie(BYBIT_GUID_KEY, guid, getCookieDomain(), '/', 120 * 24 * 60);
  return guid;
};

export { urlCacheClosure, getPrimaryKey, getGaClientId, getGuid, getReportUrl, getLoggerInstance, getCookieDomain, cacheCookie, getTdId, setTdId, getUserAgent, setUCache, getUCache, getUid };